import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import {
  ButtonColor,
  ButtonColorType,
  ButtonIconColor,
  ButtonIconColorType,
  ButtonLabelPosition,
  ButtonLabelPositionType,
  ButtonOption,
  ButtonOptionType,
  ButtonSize,
  ButtonSizeType,
  ButtonType,
  FormButtonType,
} from 'src/app/model';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() label: string;

  @Input() labelPosition: ButtonLabelPositionType = ButtonLabelPosition.PREFIX;

  @Input() tooltip: string;

  @Input() disabled: boolean = null;

  @Input() type: FormButtonType = ButtonType.BUTTON;

  @Input() icon: string;

  @Input() hoverIcon: string = '';

  @Input() iconSize: number;

  @Input() option: ButtonOptionType = ButtonOption.BASIC;

  @Input() color: ButtonColorType = ButtonColor.PRIMARY;

  @Input() iconColor: ButtonIconColorType = ButtonIconColor.DEFAULT;

  @Input() size: ButtonSizeType = ButtonSize.DEFAULT;

  @Output() clicked = new Subject<MouseEvent>();

  readonly BUTTON_LABEL_POSITION = ButtonLabelPosition;
  readonly BUTTON_OPTION = ButtonOption;

  constructor() {}

  ngOnInit(): void {}

  /**
   * Determines whether button click on
   * @param event
   */
  onButtonClick(event: MouseEvent) {
    this.clicked.next(event);
  }
}
